import { yupResolver } from '@hookform/resolvers/yup';
import { TOptions } from 'i18next';
import * as yup from 'yup';

export function getValidationSchema(
	t: (key: string, options?: TOptions | string) => string
) {
	return yup.object().shape({
		email: yup.string().email(t('email.error')).required(t('general.required')),
	});
}

export const EmailValidation = (t: (key: string) => string) =>
	yupResolver(getValidationSchema(t));
